import { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InvestorLayout from '../components/investor/InvestorLayout';
import StepNavigation from '../components/investor/StepNavigation';
import { Step1_EnergyDistributed, Step2_SiteNeedsBrain } from '../components/investor/steps/Act1Steps';
import { Step3_PlatformOverview, Step4_BusinessModel, Step5_BeachheadExpansion } from '../components/investor/steps/Act2Steps';
import { Step6_SiteDNA, Step7_Solver, Step8_Coordination } from '../components/investor/steps/Act3Steps';
import { Step9_AINative, Step10_TheAsk } from '../components/investor/steps/Act4Steps';

const STEPS = [
    { title: 'Energy Is Going Distributed', act: 'Act 1 — The Shift' },
    { title: 'Every Site Needs a Brain', act: 'Act 1 — The Shift' },
    { title: 'Intelligence + Control', act: 'Act 2 — The Platform' },
    { title: 'Asset-Light Model', act: 'Act 2 — The Platform' },
    { title: 'Beachhead + Expansion', act: 'Act 2 — The Platform' },
    { title: 'Site DNA', act: 'Act 3 — The Depth' },
    { title: 'The Solver', act: 'Act 3 — The Depth' },
    { title: 'Multi-Agent Coordination', act: 'Act 3 — The Depth' },
    { title: 'AI-Native Operations', act: 'Act 4 — The Business' },
    { title: 'The Ask', act: 'Act 4 — The Business' },
];

/**
 * Main investor demo page — 10-step guided story.
 * Public route, no auth required.
 */
export default function InvestorDemo() {
    const navigate = useNavigate();
    const { step: stepParam } = useParams();
    const initialStep = stepParam ? Math.max(0, Math.min(parseInt(stepParam, 10) - 1, STEPS.length - 1)) : 0;
    const [currentStep, setCurrentStep] = useState(isNaN(initialStep) ? 0 : initialStep);

    const handleStepChange = useCallback((newStep) => {
        setCurrentStep(newStep);
        // Update URL without full navigation
        navigate(`/investor/${newStep + 1}`, { replace: true });
    }, [navigate]);

    const handleClose = useCallback(() => {
        navigate('/');
    }, [navigate]);

    const handleTryPlatform = useCallback(() => {
        navigate('/dashboard');
    }, [navigate]);

    const stepComponents = [
        <Step1_EnergyDistributed key={0} visible={currentStep === 0} />,
        <Step2_SiteNeedsBrain key={1} visible={currentStep === 1} />,
        <Step3_PlatformOverview key={2} visible={currentStep === 2} />,
        <Step4_BusinessModel key={3} visible={currentStep === 3} />,
        <Step5_BeachheadExpansion key={4} visible={currentStep === 4} />,
        <Step6_SiteDNA key={5} visible={currentStep === 5} />,
        <Step7_Solver key={6} visible={currentStep === 6} />,
        <Step8_Coordination key={7} visible={currentStep === 7} />,
        <Step9_AINative key={8} visible={currentStep === 8} />,
        <Step10_TheAsk key={9} visible={currentStep === 9} onTryPlatform={handleTryPlatform} />,
    ];

    return (
        <InvestorLayout
            currentStep={currentStep}
            totalSteps={STEPS.length}
            actLabel={STEPS[currentStep]?.act}
            onClose={handleClose}
        >
            {stepComponents[currentStep]}

            <StepNavigation
                currentStep={currentStep}
                totalSteps={STEPS.length}
                onStepChange={handleStepChange}
                stepTitles={STEPS.map(s => s.title)}
            />
        </InvestorLayout>
    );
}
